import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const {
  FILE_UPLOAD_COLOR,
  FILE_UPLOAD_ICON_COLOR,
  DANGER_STATUS_COLOR
} = constants;

let styles = {
  dropzone: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '25px 0'
  },
  label: {
    fontWeight: 600,
    color: FILE_UPLOAD_COLOR,
    margin: '0 auto'
  },
  filename: {
    fontWeight: 800,
    color: FILE_UPLOAD_COLOR,
    margin: '0 auto'
  },
  icon: {
    fontSize: 130,
    color: FILE_UPLOAD_ICON_COLOR,
    margin: '0 auto 8px'
  },
  errors: {
    display: 'flex',
    flexDirection: 'column',
    margin: '8px auto 0'
  },
  error: {
    fontSize: '0.9em',
    fontWeight: 500,
    paddingTop: 3,
    paddingLeft: 1,
    color: DANGER_STATUS_COLOR
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/fileinput/FileInput.styles.js